export default {"src":"/_next/static/media/mobile-app.c9af1c4c.svg","height":787,"width":738};